var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-main"},[_c('Row',{staticClass:"code-row"},[_c('Col',{attrs:{"span":"24"}},[_c('indexHome')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }